export default {
    enable: {
        type: Boolean,
        default: undefined
    },
    icon: {
        type: String,
        default: undefined
    },
    iconClass: {
        type: String,
        default: undefined
    },
    imageUrl: {
        type: String,
        default: undefined
    },
    spriteCssClass: {
        type: String,
        default: undefined
    },

    // Events
    click: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-buttons-vue-wrapper/src/KendoButton/ButtonProps.js